const address = "82/1, Bajirao Dhawade Patil Industrial Estate, NDA Road, Shivane, Pune, 411023";

const company = {
  phone: "+91 88303 73558",
  phoneRaw: "+918830373558",
  phoneAlt: "+91 74209 81100",
  phoneAltRaw: "+917420981100",
  email: "contact@sutramayindustries.com",
  address,
  businessHours: "Monday – Saturday, 9:00 AM – 6:00 PM IST",
  mapsDirectionsUrl: `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`,
  mapsSearchUrl: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`,
  social: {
    // Real handles are not yet available for these — placeholders only, no invented URLs.
    instagram: "#",
    facebook: "#",
    linkedin: "#",
    youtube: "#",
    twitter: "#",
    // "Google" maps to our Maps location since no Google Business profile URL is available.
    google: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`,
  },
};

export default company;
